import { AxiosResponse } from 'axios';
import { APIResponse } from '../types/api-response';

class ValidationResponseError<TFields> extends Error {
    constructor(public fieldErrors: TFields) {
        super('Validation error');
        this.name = 'ValidationResponseError';
    }

    static throwIfMatches(data: AxiosResponse<APIResponse<unknown>>) {
        if (
            data.status === 400
            && data.data.success === false
            && 'fieldErrors' in data.data
            && data.data.fieldErrors !== undefined
        ) {
            throw new ValidationResponseError(data.data.fieldErrors);
        }
    }
}

function isValidationResponseError<TFields>(
    ex: unknown
): ex is ValidationResponseError<TFields> {
    return (
        ex instanceof ValidationResponseError
        && typeof ex.fieldErrors === 'object'
        && ex.fieldErrors !== null
    );
}

export {
    ValidationResponseError,
    isValidationResponseError,
};
